import type { ExpertProfile } from "../../types/Profiles/expertProfile.types";
import ExpertCompanyTab from "./tabs/ExpertCompanyTab";
import { ExpertActivityTab, ExpertAidaAdhesionTab, ExpertCertificationsTab, ExpertServicesTab } from "./tabs/ExpertSimpleTabs";

interface Props {
  profile: ExpertProfile;
  activeTab: string;
  setActiveTab: (tab: string) => void;
  userId?: number | string | null;
  onProfileUpdated?: () => Promise<void> | void;
}

const tabs = [
  { key: "company", label: "Entreprise" },
  { key: "services", label: "Services" },
  { key: "certifications", label: "Certifications" },
  { key: "activity", label: "Activite" },
  { key: "aida_adhesion", label: "Adhesion AIDA" },
];

export default function ExpertProfileTabs({ profile, activeTab, setActiveTab, userId, onProfileUpdated }: Props) {
  return (
    <>
      <div className="card border-0 shadow-sm rounded-4 mb-4">
        <div className="card-body p-3">
          <ul className="nav nav-pills gap-2 flex-wrap">
            {tabs.map((tab) => (
              <li className="nav-item" key={tab.key}>
                <button type="button" className={`nav-link rounded-3 ${activeTab === tab.key ? "active" : ""}`} onClick={() => setActiveTab(tab.key)}>
                  {tab.label}
                </button>
              </li>
            ))}
          </ul>
        </div>
      </div>

      {activeTab === "company" && <ExpertCompanyTab profile={profile} userId={userId} onProfileUpdated={onProfileUpdated} />}
      {activeTab === "services" && <ExpertServicesTab profile={profile} userId={userId} onProfileUpdated={onProfileUpdated} />}
      {activeTab === "certifications" && <ExpertCertificationsTab profile={profile} userId={userId} onProfileUpdated={onProfileUpdated} />}
      {activeTab === "activity" && <ExpertActivityTab profile={profile} />}
      {activeTab === "aida_adhesion" && <ExpertAidaAdhesionTab profile={profile} />}
    </>
  );
}
